import PropTypes from "prop-types";
import Button from "../Button";

const SignInButton = ({ login, className }) => (
  <Button
    action={login}
    contentKey={"saved_items_sign_in_btn"}
    className={className}
  />
);

SignInButton.propTypes = {
  login: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default SignInButton;
